import { lazy, Suspense } from "react";
import { Switch, Route } from "react-router-dom";
import Footer from "../components/Footer";
import Header from "../components/Header";
import routes from "./config";
import { Styles } from "../styles/styles";
import AnimatedCursor from "react-animated-cursor";

const Router = () => {
  return (
    <Suspense fallback={null}>
      <Styles />
      <Header />
      <AnimatedCursor
        innerSize={12}
        outerSize={40}
        color="38, 122, 141"
        outerAlpha={0.35}
        innerScale={1.2}
        outerScale={6}
        showSystemCursor={false}
        trailingSpeed={8}
        clickables={[
          "a",
          "textarea",
          "button",
          "select",
          ".link",
          ".custom-hover",
          ".slide-item",
          ".testimonial-card",
          ".stat-box",
          ".step-circle",
        ]}
      />
      <Switch>
        {routes.map((routeItem) => {
          return (
            <Route
              key={routeItem.component}
              path={routeItem.path}
              exact={routeItem.exact}
              component={lazy(() => import(`../pages/${routeItem.component}`))}
            />
          );
        })}
      </Switch>
      <Footer />
    </Suspense>
  );
};

export default Router;
